import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SubmissionError } from "redux-form";
import { FormattedMessage } from "react-intl";

import ExportMembersForm from "./ExportMembersForm";
import { BSModal } from "../../../common";
import AuthorizationForm from "./AuthorizationForm";
import * as downloaderActions from "../../../../utils/downloader/downloaderActions";

import * as dataActions from "../../../../utils/data/dataActions";
import * as types from "../../../../utils/data/dataActionTypes";
import { ADMINISTRATOR, DIRECTOR, FINTECH, MANAGER } from "../../../../utils/Roles";
import userHasAccess from "../../../../utils/userHasAccess";
import { CLIENTS, CLIENTS_GRAPHQL, BILLING_PERIODS } from "../../../../utils/data/models";
import englishTranslations from "../../../../components/intl/en-CA";
import frenchTranslations from "../../../../components/intl/fr-CA";
import { toast } from "react-toastify";
import { canDownload } from "../../../common/CanDownload";
import { downloaderEnums } from "../../../../utils/downloader/downloaderEnums";
import { arrayToFilterStr, buildGraphQLQueryParams } from "../../../common/GraphQL/GraphQLQueryHelper";
import { isClientInTransition } from "../../../common/RouteValidators/ClientValidationHelper";

class ExportMembersPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showAuthorizationCodeModal: false,
      exportValues: null,
      exporting: false,
      downloadPath: null
    };

    this.getGraphQLQuery = this.getGraphQLQuery.bind(this);
    this.closeAuthorizationCodeForm = this.closeAuthorizationCodeForm.bind(
      this
    );
    this.download = this.download.bind(this);
    this.handleClientChange = this.handleClientChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onExport = this.onExport.bind(this);
    this.buildDescription = this.buildDescription.bind(this);
    this.getFileFormatName = this.getFileFormatName.bind(this);
    this._initialize = this._initialize.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(BILLING_PERIODS);
    let filters = [CLIENTS_GRAPHQL.archiveFilter, CLIENTS_GRAPHQL.currentClientsFilter];
    if(!userHasAccess([DIRECTOR, MANAGER, ADMINISTRATOR, FINTECH], true)) {
      filters.push(CLIENTS_GRAPHQL.nonMEVClientsFilter);
    }
    filters = arrayToFilterStr(filters);
    const sort = [CLIENTS_GRAPHQL.defaultSort];
    const graphQLQuery = this.getGraphQLQuery(filters, sort, 0, 0, "getClients", "");
    this.props.dataActions.getGraphQL(CLIENTS_GRAPHQL, { query: graphQLQuery }, sort);
  }

  componentDidMount() {
    this._initialize();
  }

  componentDidUpdate(){
    
    if(this.state.downloadPath){
      
      if(this.props.successDownloads.length > 0){
        let finishedDownloadObj = this.props.successDownloads.find(download => download.path == this.state.downloadPath);

        if(finishedDownloadObj){
          this.setState({downloadPath: null});
          
          this._initialize();
        }
      }
      if(this.props.errorDownloads.length > 0){
        
        let finishedDownloadObj = this.props.errorDownloads.find(download => download.path == this.state.downloadPath);
        
        if(finishedDownloadObj){
          this.setState({downloadPath: null});
          this._initialize();
        }
        
      }
    }
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList(BILLING_PERIODS);
  }

  _initialize() {
    this.setState({ exporting: false });
    this.props.dataActions.clearDataFile(CLIENTS);
  }

  getGraphQLQuery(filter, sortBy, offset, limit, queryName, q) {
    const colsStr = `
        clientId
        name
        clientBillingPeriodType
        shouldImportWithoutId
    `;
    return buildGraphQLQueryParams("clients", filter, sortBy, offset, limit, colsStr, queryName, q);
  }

  closeAuthorizationCodeForm() {
    this.setState({ showAuthorizationCodeModal: false });
  }

  buildDescription(values, fileFormatKey){
    /**
     * Function that will build download info according to the requested file's
     * information.
     */
    const userLanguage = localStorage.getItem("languageCode") || "en-CA";
    let billingPeriodObject = this.props.billingPeriods.find(billingPeriod => billingPeriod.billingPeriodId == values.billingPeriodId);
    let billingPeriod = billingPeriodObject.startDate + " - " + billingPeriodObject.endDate;
    let clientObject = this.props.clients.find(client => client.clientId == values.clientId);

    let translationFile;

    if (userLanguage == "fr-CA") {
      translationFile = frenchTranslations;
    }
    else{
      translationFile = englishTranslations;
    }

    let fileFormatName = this.getFileFormatName(fileFormatKey, translationFile);

    if(userLanguage == "fr-CA"){
      return frenchTranslations.downloader.clientExport + " " + clientObject.name + "\n" + billingPeriod + ", " + fileFormatName  + ": " + values.languageCode;
    }
    return englishTranslations.downloader.clientExport + " " + clientObject.name + "\n" + billingPeriod + ", " + fileFormatName  + ": " + values.languageCode;

  }

  getFileFormatName(key, translationFile){
    switch(key){
      case "SYMBILITY":
        return translationFile.downloader.symbility;
        case "MONDIAL":
          return translationFile.downloader.mondial;
       case "FEUS":
        return translationFile.downloader.feus;
    }
  }

  download(values) {
    const formValues = !!this.state.exportValues
      ? { ...values, ...this.state.exportValues }
      : values;
    const fileFormat = !!formValues.fileFormat
      ? formValues.fileFormat
      : "MONDIAL";
    const path = `${formValues.clientId}/export`;
    const body = {
      billingPeriodId: formValues.billingPeriodId,
      fileFormat,
      mustHaveMemberIdentifierRecoveryDate:
        formValues.mustHaveMemberIdentifierRecoveryDate,
      createCookie: true,
      authorizationCode: formValues.authorizationCode || null,
      languageCode: formValues.languageCode
    };
    const description = this.buildDescription(
      // values can contain less than expected payload data if user hasn't FINANCE role.
      // In this case, first form sent here is the authorization code validation.
      this.state.exportValues != null ? this.state.exportValues : values, 
      fileFormat
    );

    return this.props.dataActions
      .postDataFile(CLIENTS, path, body, {})
      .then((data) => {
        if (data.type === types.POST_DATA_FILE_FAILURE) {
          throw new SubmissionError({
            authorizationCode: {
              messageKey:
                "validation.customMessages.serverErrors.wrongAuthorizationCode",
              values: {},
              state: "error",
            },
          });
        } else {
          if(canDownload(description, this.props.currentDownloads)){
            this.setState({ exportValues: null, exporting: true });
            this.closeAuthorizationCodeForm();
            this.setState({ downloadPath: this.props.shortLivedURL });
            this.props.downloaderActions.downloadFile(this.props.shortLivedURL, description);
          }
          else{
            toast(
              <FormattedMessage id="downloader.duplicateDownload" values={{ file: description , br: <br/>}} />,
              {
                type: toast.TYPE.ERROR,
                autoClose: downloaderEnums.AUTO_CLOSE
              }
            );
          }
        }
      });
  }

  handleClientChange(event) {
    const value = event.target.value;
    isClientInTransition(value).then((res) => {
      this.props.setShowTransitionWarning(res);
    });
    if (value === " ") {
      return this.props.dataActions.clearDataList(BILLING_PERIODS);
    }
    return this.props.dataActions.getDataList(
      BILLING_PERIODS,
      0,
      0,
      "",
      ["startDate:desc"],
      ["billingPeriods.clientId==" + value],
      {},
      "clientId,startDate,endDate,localizations"
    );
  }

  onClick() {
    this.refs.form.getWrappedInstance().submit();
  }

  onExport(values) {
    if (!userHasAccess(MANAGER)) {
      this.setState({ exportValues: values, showAuthorizationCodeModal: true });
    } else {
      this.download(values);
    }
  }

  render() {
    const renderModal = !userHasAccess(MANAGER);

    return (
      <div>
        <ExportMembersForm
          billingPeriods={this.props.billingPeriods}
          clients={this.props.clients}
          handleClientChange={this.handleClientChange}
          onSubmit={this.onExport}
          exporting={this.props.exporting || this.state.exporting}
          user={this.props.auth.user}
        />

        {renderModal && (
          <BSModal
            show={this.state.showAuthorizationCodeModal}
            title={
              <FormattedMessage id="configurationsForm.enterAuthorizationCode" />
            }
            actions={[
              {
                id: 1,
                disabled: false,
                text: <FormattedMessage id="common.confirm" />,
                action: this.onClick,
              },
            ]}
            onClose={this.closeAuthorizationCodeForm}
          >
            <AuthorizationForm ref={"form"} onSubmit={this.download} />
          </BSModal>
        )}
      </div>
    );
  }
}

ExportMembersPage.propTypes = {
  auth: PropTypes.object,
  billingPeriods: PropTypes.array,
  clients: PropTypes.array,
  cookieName: PropTypes.string,
  currentDownloads: PropTypes.array,
  dataActions: PropTypes.object,
  downloaderActions: PropTypes.object,
  errorDownloads: PropTypes.array,
  exporting: PropTypes.bool,
  shortLivedURL: PropTypes.string,
  setShowTransitionWarning: PropTypes.func,
  successDownloads: PropTypes.array,
};

function mapStateToProps(state) {
  const billingPeriods = state.data.billingPeriods || {};
  const clients = state.data.clients || {};
  const file = clients.shortLivedURL || {};
  const downloads = state.downloader || {};

  return {
    auth: state.auth,
    billingPeriods: billingPeriods.items || [],
    clients: clients.items || [],
    cookieName: file.cookieName || null,
    exporting: state.data.submitting,
    shortLivedURL: file.fileUrl || null,
    currentDownloads: downloads.files || [],
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    downloaderActions: bindActionCreators(downloaderActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportMembersPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exportMembers/ExportMembersPage.js